import { Mail, Wine, Send, UserPlus, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useAuth } from "@/context/AuthContext";

export default function SubmitWines() {
  const { user } = useAuth();
  const isPartner = user?.role === "partner" || user?.role === "admin";
  return (
    <main className="pt-24 pb-20 min-h-screen" data-testid="submit-wines-page">
      <div className="max-w-[800px] mx-auto px-6">
        <div className="mb-12">
          <p className="font-accent text-xs tracking-[0.3em] text-gold/60 mb-2">SUBMISSIONS</p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white/95 leading-tight">
            Where to Submit Wines for Reviews
          </h1>
        </div>

        <Separator className="bg-white/5 mb-10" />

        <div className="space-y-8">
          <div className="glass-card rounded-sm p-8">
            <div className="flex items-start gap-4">
              <Wine className="w-5 h-5 text-merlot mt-1 shrink-0" />
              <div>
                <h2 className="font-display text-xl text-white/90 mb-4">Easy Way to Submit Wines for AlfredWine.com Reviews</h2>
                <p className="font-body text-sm text-white/60 leading-relaxed">
                  AlfredWine.com review wines from around the world.
                </p>
              </div>
            </div>
          </div>

          <div className="glass-card rounded-sm p-8">
            <p className="font-body text-sm text-white/60 leading-relaxed">
              AlfredWine.com goal is to review wine of good quality submited by wineries, cellars, importers, hotels, cuises, restaurants, and related business.
            </p>
          </div>

          <div className="glass-card rounded-sm p-8">
            <p className="font-body text-sm text-white/60 leading-relaxed">
              Also, AlfredWine.com and partners can buy wines that are not submitted for review.
            </p>
          </div>

          <div className="glass-card rounded-sm p-8">
            <div className="flex items-start gap-4">
              <Send className="w-5 h-5 text-gold mt-1 shrink-0" />
              <div>
                <h2 className="font-display text-xl text-white/90 mb-4">How to submit a wine sample?</h2>
                <p className="font-body text-sm text-white/60 leading-relaxed">
                  Please submit two bottles of wine for each review together with clear information about vineyard location, grape type, winery, year, etc.
                </p>
              </div>
            </div>
          </div>

          <div className="glass-card rounded-sm p-8">
            <div className="flex items-start gap-4">
              <Mail className="w-5 h-5 text-gold mt-1 shrink-0" />
              <div>
                <h2 className="font-display text-xl text-white/90 mb-4">Where to submit my sample?</h2>
                <p className="font-body text-sm text-white/60 leading-relaxed mb-4">
                  Please contact us for more information:
                </p>
                <a
                  href="mailto:tastings@alfredwines.com"
                  data-testid="submit-email-link"
                  className="inline-flex items-center gap-2 font-body text-sm text-gold hover:text-gold-light transition-colors duration-300"
                >
                  <Mail className="w-4 h-4" />
                  tastings@alfredwines.com
                </a>

                {isPartner && (
                  <div
                    className="mt-6 pt-6 border-t border-white/5 flex items-start gap-3"
                    data-testid="partner-postal-address"
                  >
                    <MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" />
                    <div>
                      <p className="font-body text-[10px] tracking-wider text-white/40 uppercase mb-1">
                        Postal Address
                      </p>
                      <p className="font-body text-sm text-white/80 leading-relaxed">
                        AlfredWine.com<br />
                        Torre de Binixiquet<br />
                        07714 Balearic Islands, Spain
                      </p>
                    </div>
                  </div>
                )}

                {!user && (
                  <div className="mt-6 pt-6 border-t border-white/5" data-testid="submit-signup-cta">
                  <p className="font-body text-xs text-white/40 mb-3">
                    Want to submit wines directly through the platform? Create a free Partner account.
                  </p>
                  <Link to="/register">
                    <Button
                      data-testid="submit-create-account-btn"
                      className="bg-merlot hover:bg-merlot-light text-white gap-2 font-body text-sm h-10 rounded-sm shadow-[0_0_15px_rgba(158,42,43,0.25)] transition-all duration-300"
                    >
                      <UserPlus className="w-4 h-4" />
                      Create Free Account
                    </Button>
                  </Link>
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
